<template>
  <div>
    <div v-if="isdetails">
      <tpldetails></tpldetails>
    </div>
    <div v-if="!isdetails">
      <pcdetails></pcdetails>
    </div>
  </div>
</template>
<script>
  import tpldetails from './activeInfo_tpl'
  import pcdetails from './activeInfo_pc'
  export default {
    data() {
      return {
        isdetails:true,
      }
    },
    props: {},
    methods: {},
    computed: {

    },
    components:{
      tpldetails,
      pcdetails
    },
    mounted() {
      let sUserAgent = navigator.userAgent.toLowerCase();
      if (/ipad|iphone|midp|rv:1.2.3.4|ucweb|android|windows ce|windows mobile/.test(sUserAgent)) {
        //跳转移动端页面
        this.isdetails = true;
      } else  {
        this.isdetails = false;

      }

    }
  }
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/container/activeInfo.vue